module.exports = __webpack_public_path__ + "static/media/score_aWIN.aa9ad824.png";